import axios from 'axios';
import MockAdapter from 'axios-mock-adapter';
const axiosInstance = axios.create();
const Mock = new MockAdapter(axiosInstance);
export default Mock;
